import { useEffect } from 'react';

export default function Modal({ open, title, onClose, children }) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="app-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title || 'Окно'}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="app-modal">
        <div className="app-modal-header">
          <div className="app-modal-title">{title || ''}</div>
          <button type="button" className="btn btn-outline btn-xs btn-icon-only" onClick={onClose} aria-label="Закрыть" title="Закрыть">
            ✕
          </button>
        </div>
        <div className="app-modal-body">{children}</div>
      </div>
    </div>
  );
}

